<div
  class="revoke-modal"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="revoke-proxy-title"
  aria-describedby="revoke-proxy-description"
  appFocusTrap
>
  <header class="revoke-modal__header flex align-center justify-between">
    <div class="flex align-center gap-12">
      <span class="revoke-modal__header-icon" aria-hidden="true">
        <app-icon
          name="person_remove"
          size="sm"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
      </span>
      <div>
        <h2 id="revoke-proxy-title" class="revoke-modal__title fs-16 fw-700 m-0">
          Revoke Proxy Access
        </h2>
        <p class="fs-12 m-0 revoke-modal__subtitle">{{ proxyName() }}</p>
      </div>
    </div>
    <button
      type="button"
      class="revoke-modal__close"
      (click)="cancel()"
      aria-label="Close revoke proxy access dialog"
    >
      <app-icon
        name="close"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
    </button>
  </header>

  <div class="revoke-modal__body">
    <!-- The question and its consequence in one sentence, because the consequence is the reason
         the dialog exists: the link does not pause, it closes, and re-granting it takes a fresh
         proxy verification request. -->
    <p id="revoke-proxy-description" class="revoke-modal__prompt fs-12 m-0">
      Revoke portal access for <strong>{{ proxyName() }}</strong>? They will immediately lose the
      ability to view records.
    </p>

    <div class="revoke-modal__actions flex justify-end align-center gap-12">
      <button type="button" class="secondary-button fw-600 revoke-modal__cancel" (click)="cancel()">
        Cancel
      </button>
      <button
        type="button"
        class="danger-button fw-600 flex align-center gap-8 revoke-modal__confirm"
        [attr.aria-label]="'Revoke portal access for ' + proxyName()"
        (click)="confirm()"
      >
        <app-icon
          name="person_remove"
          size="xs"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
        <span>Revoke Access</span>
      </button>
    </div>
  </div>
</div>
